import { all, call, put, takeLatest, delay } from 'redux-saga/effects';
import * as api from '../../../api';
import { createAsyncSaga, Actions } from '@wahaaabello/redux-async-actions';
import pagesActions from './actions';
import { appendPageDataToPageId } from '../../../helpers/utils';

function* fetchHomePage() {
  try {
    const pageData = yield call(api.fetchHomePage);
    yield put(
      pagesActions.fetchHomePageSuccess({
        pageId: 'home',
        pageData
      })
    );
    return pageData;
  } catch (error) {
    yield put(pagesActions.fetchHomePageFailure(error));
    throw error;
  }
}

function* fetchUserPage(action: Actions) {
  try {
    const pageData = yield call(api.fetchUserPage, action.payload);
    yield put(
      pagesActions.fetchUserPageSuccess({
        pageData,
        pageId: action.payload
      })
    );
    return pageData;
  } catch (error) {
    yield put(pagesActions.fetchUserPageFailure(error));
    throw error;
  }
}

function* fetchPage({ payload }: Actions<string | { pageId: string }>) {
  let pageId;
  let others: { [key: string]: any };
  try {
    if (typeof payload === 'object') {
      ({ pageId, ...others } = payload);
    } else {
      pageId = payload;
      others = {};
    }
    yield delay(500);
    const pageDataResponse = yield call(api.fetchPage, pageId, others);
    yield put(
      pagesActions.fetchPageSuccess({
        pageData: pageDataResponse,
        pageId: appendPageDataToPageId(pageId, others)
      })
    );
    return {
      ...pageDataResponse,
      pagedata: {
        ...pageDataResponse.pagedata,
        ...(typeof payload === 'object' ? payload : {})
      }
    };
  } catch (error) {
    yield put(pagesActions.fetchPageFailure(error));
    throw error;
  }
}

function* fetchSafelocks() {
  try {
    const pageData = yield call(api.listSafelocks);
    yield put(
      pagesActions.fetchPageSuccess({
        pageData,
        pageId: 'safelocks'
      })
    );
    return pageData;
  } catch (error) {
    yield put(pagesActions.fetchPageFailure(error));
    throw error;
  }
}

export default function* pagesSaga() {
  yield all([
    takeLatest(
      pagesActions.fetchHomePageRequest.toString(),
      createAsyncSaga(fetchHomePage)
    ),
    takeLatest(
      pagesActions.fetchUserPageRequest.toString(),
      createAsyncSaga(fetchUserPage)
    ),
    takeLatest(
      pagesActions.fetchPageRequest.toString(),
      createAsyncSaga(fetchPage)
    ),
    takeLatest(
      pagesActions.fetchSafelocksRequest.toString(),
      createAsyncSaga(fetchSafelocks)
    )
  ]);
}
